import { useState } from 'react'

/**
 * Allows a function to only be called once. Useful for buttons.
 * Returns a second function to reset the callback state incase
 * the function needs to be attempted again.
 * e.g. an API call fails and it needs to be re-submitted
 */
const useCallbackOnce = (): [(cb: () => unknown) => void, () => void] => {
  const [called, setCalled] = useState(false)

  return [
    (callback: () => unknown) => {
      if (!called) {
        setCalled(true)
        callback()
      }
    },
    () => {
      setCalled(false)
    }
  ]
}

export default useCallbackOnce
